<template>
  <div class="md-layout-item">
    <form class="modal-content">
      <div class="rejected_box invalid_color"
           v-if="contractData.rejectReason">
        <div>{{ $t("rejectModal.rejectReason") }}:</div>
        <div class="reason_text">{{ contractData.rejectReason }}</div>
      </div>
      <div class="flex_1" style="height: 25px"></div>
      <div class="md-layout-item flex_column" style="width:560px; margin-left: 10rem;">
        <ProductGroupSelect
            required
            :disabled="isDisabled()"
            v-model="form.shipment.productGroupId"
            data-vv-name="productGroupId"
            v-validate="modelValidations.productGroup"
            v-on:input="changeProductGroup"
            :error="errors.first('productGroupId')"
            ref="ProductGroupSelectBox"
        ></ProductGroupSelect>
        <div>
          <div class="margin_2">
            <p class="form_label_head">
              {{ $t("trackPay.contractsEditModal.productDescription") }}
            </p>
            <md-field>
              <md-textarea
				          v-model="form.shipment.productDescription"
                  :disabled="isDisabled()"
                  class="textarea note-textarea base_padding"
                  :md-autogrow="true"
                  required
              ></md-textarea>
            </md-field>
          </div>
        </div>
        <p class="form_label_head">
          {{ $t("trackPay.contractsEditModal.transport") }}
        </p>
        <div class="checkBox_group">
          <md-checkbox style="margin-top: 8px" :disabled="isDisabled()" v-for="item in form.modesOfTransport"
                       v-model="item.vModel" @change="resetDeviceProfile" :key="item.name"
          >{{ $t(item.name + "") }}
          </md-checkbox>
        </div>
        <div class="margin_2">
          <p class="form_label_head">
            {{ $t("trackPay.contractsEditModal.paymentTip") }}
          </p>
          <md-field :class="[{ 'md-error': errors.has('incoTerms') }]">
            <label>
              {{ $t("trackPay.contractsEditModal.incoterm") }}
            </label>
            <TbSelect
                v-model="form.shipment.incoTerms"
                data-vv-name="incoTerms"
                v-validate="modelValidations.incoTerms"
                :search-allow="true"
                :disabled="isDisabled()"
                :required="true"
                :options="incotermOption"
                options-value-field="value"
                options-display-field="label"
            />
            <span v-if="errors.has('incoTerms')" class="validation-error">{{ errors.first('incoTerms') }}</span>
          </md-field>
        </div>
        <p class="form_label_head">
          {{ $t("trackPay.contractsEditModal.dapCoordinates") }}
        </p>
        <md-field :class="[{ 'md-error': errors.has('latitude') }]">
          <label>{{ $t("trackPay.contractsEditModal.latitude") }}</label>
          <MoneyAmountInput
              v-model="form.shipment.destination.latitude"
              data-vv-name="latitude"
              :required="true"
              :disabled="isDisabled()"
              :decimals=10
              v-validate="modelValidations.latitude">
          </MoneyAmountInput>
        </md-field>
        <md-field :class="[{ 'md-error': errors.has('longitude') }]">
          <label>{{ $t("trackPay.contractsEditModal.longitude") }}</label>
          <MoneyAmountInput
              v-model="form.shipment.destination.longitude"
              data-vv-name="longitude"
              :required="true"
              :disabled="isDisabled()"
              :decimals=10
              v-validate="modelValidations.longitude">
          </MoneyAmountInput>
        </md-field>
        <div class="flex flex_between">
          <md-field
              class="flex_1"
              :class="[{ 'md-error': errors.has('radius') }]">
            <label>{{ $t("trackPay.contractsEditModal.tolerance") }}</label>
            <MoneyAmountInput
                v-model="form.shipment.destination.radius"
                data-vv-name="radius"
                :required="true"
                :disabled="isDisabled()"
                v-validate="modelValidations.radius">
            </MoneyAmountInput>
          </md-field>
          <span>m radius</span>
        </div>
        <div class="margin_2">
          <p class="form_label_head">
            {{ $t("trackPay.shipment.numberOfTrackersHeader") }}
          </p>
          <md-field :class="[{ 'md-error': errors.has('numberOfDevices') }]">
            <label> {{ $t("trackPay.shipment.numberOfTrackers") }} </label>
            <md-input
                v-model="form.shipment.numberOfDevices"
                data-vv-name="numberOfDevices"
                v-validate="modelValidations.numberOfDevices"
                :disabled="isDisabled()"
                required>
            </md-input>
            <span v-if="errors.has('numberOfDevices')"
                  class="validation-error">{{ errors.first("numberOfDevices") }}</span>
          </md-field>
        </div>
		<div class="margin_2 form_item text_left">
		  <p class="form_label_head"> {{ $t("trackPay.shipment.orderDevices") }} </p>
		  <md-checkbox v-model="form.shipment.orderDevices"> </md-checkbox>
		</div>
		<p class="form_label_head">
			  {{ $t("trackPay.contractsEditModal.trackerReceiverAddress") }}
			  <el-tooltip :content="$t('trackPay.contractsEditModal.trackerReceiverAddress.tooltip')" placement="top">
				  <i class="fa fa-info-circle secondary_color" aria-hidden="true"></i>
			  </el-tooltip>
		</p>
		<md-field :class="[{ 'md-error': errors.has('companyName') }]">
			<label>{{ $t("common.companyName") }}</label>
			<md-input
				  v-model="form.shipment.fromAddress.companyName"
				  data-vv-name="companyName"
				  v-validate="modelValidations.companyName"
				  required
				  :disabled="isDisabled()"
			></md-input>
			<span v-if="errors.has('companyName')" class="validation-error">{{ errors.first("companyName") }}</span>
		</md-field>
        <md-field :class="[{ 'md-error': errors.has('firstName') }]">
          <label>{{ $t("common.firstName") }}</label>
          <md-input
              v-model="form.shipment.fromAddress.contact.firstName"
              data-vv-name="firstName"
              v-validate="modelValidations.firstName"
              required
              :disabled="isDisabled()"
          ></md-input>
          <span v-if="errors.has('firstName')" class="validation-error">{{ errors.first("firstName") }}</span>
        </md-field>
        <md-field :class="[{ 'md-error': errors.has('lastName') }]">
          <label>{{ $t("common.lastName") }}</label>
          <md-input
              v-model="form.shipment.fromAddress.contact.lastName"
              data-vv-name="lastName"
              v-validate="modelValidations.lastName"
              required
              :disabled="isDisabled()"
          ></md-input>
          <span v-if="errors.has('lastName')" class="validation-error">{{ errors.first("lastName") }}</span>
        </md-field>
        <md-field :class="[{ 'md-error': errors.has('streetName') }]">
          <label>{{ $t("common.street") }}</label>
          <md-input
              v-model="form.shipment.fromAddress.streetName"
              data-vv-name="streetName"
              v-validate="modelValidations.streetName"
              required
              :disabled="isDisabled()"
          ></md-input>
          <span v-if="errors.has('streetName')" class="validation-error">{{ errors.first("streetName") }}</span>
        </md-field>
		  <md-field :class="[{ 'md-error': errors.has('streetNumber') }]">
          <label>{{ $t("common.houseNumber") }}</label>
          <md-input
              v-model="form.shipment.fromAddress.streetNumber"
              data-vv-name="streetNumber"
              v-validate="modelValidations.streetNumber"
              required
              :disabled="isDisabled()"
          ></md-input>
          <span v-if="errors.has('streetNumber')" class="validation-error">{{ errors.first("streetNumber") }}</span>
        </md-field>
        <md-field>
          <label>{{ $t("Completion.Company.AddressAddon") }}</label>
          <md-input
              v-model="form.shipment.fromAddress.addressExtension"
              :disabled="isDisabled()"
          ></md-input>
        </md-field>
        <md-field :class="[{ 'md-error': errors.has('zipCode') }]">
          <label>{{ $t("trackPay.contractsEditModal.postalCode") }}</label>
          <md-input
              v-model="form.shipment.fromAddress.zipCode"
              data-vv-name="zipCode"
              v-validate="modelValidations.zipCode"
              required
              :disabled="isDisabled()"
          ></md-input>
          <span v-if="errors.has('zipCode')" class="validation-error">{{ errors.first("zipCode") }}</span>
        </md-field>
        <md-field :class="[{ 'md-error': errors.has('city') }]">
          <label>{{ $t("common.city") }}</label>
          <md-input
              v-model="form.shipment.fromAddress.city"
              data-vv-name="city"
              v-validate="modelValidations.city"
              required
              :disabled="isDisabled()"
          ></md-input>
          <span v-if="errors.has('city')" class="validation-error">{{ errors.first("city") }}</span>
        </md-field>
        <CountrySelect
            v-on:input="onSelectCountry"
            :labelText="$t('common.country')"
            :value="form.shipment.fromAddress.country"
            :companyType="enumDef.companyType.DebtorCompany"
            :disabled="isDisabled()"
            :required="true"
            data-vv-name="country"
            v-validate="modelValidations.country"
            :error="errors.first('country')"
        ></CountrySelect>
        <md-field :class="[{ 'md-error': errors.has('phone') }]">
            <label>{{ $t("common.phone") }}</label>
          <md-input
              v-model="form.shipment.fromAddress.contact.phone"
              data-vv-name="phone"
              v-validate="modelValidations.phone"
              required
              :disabled="isDisabled()">
          </md-input>
          <span v-if="errors.has('phone')" class="validation-error">{{ errors.first('phone') }}</span>
        </md-field>
        <md-field :class="[{ 'md-error': errors.has('email') }]">
          <label>{{ $t("common.email") }}</label>
          <md-input
              v-model="form.shipment.fromAddress.contact.email"
              data-vv-name="email"
              v-validate="modelValidations.email"
              required
              :disabled="isDisabled()">
              type="email"
          ></md-input>
          <span v-if="errors.has('email')" class="validation-error">{{ errors.first('email') }}</span>
        </md-field>
      </div>
    </form>

    <div class="flex flex_between margin_top">
      <md-button class="md-blank" @click="back">{{ $t("common.button.back") }}</md-button>
      <md-button @click="next" class="md-primary" :class="{ 'md-primary': isFormValid }"
      >{{ $t("common.button.next") }}
      </md-button>
    </div>
  </div>
</template>

<script>
import CountrySelect from "src/components/templates/select/CountrySelect.vue";
import {validateForm, validateRequiredFields} from "src/validation/validation";
import {enumDef} from "src/common/enumDefs";
import ProductGroupSelect from "./ProductGroupSelect";
import MoneyAmountInput from "../common/MoneyAmountInput";

export default {
  props: {
    contractData: {type: Object},
    readOnly: Boolean,
    isEditMode: Boolean,
		trackerForm: Object
  },
  components: {
    CountrySelect,
    ProductGroupSelect,
    MoneyAmountInput
  },
  data() {
    return {
      modelValidations: {
        numberOfDevices: {
          required: true,
          max_value: 25
        },
        country: {
          required: true
        },
        companyName: {
          required: true
        },
        firstName: {
          required: true
        },
        lastName: {
          required: true
        },
        phone: {
          required: true
        },
        email: {
          required: true
        },
        streetName: {
          required: true
        },
        streetNumber: {
          required: true
        },
        zipCode: {
          required: true
        },
        city: {
          required: true
        },
        productGroup: {
          required: true
        },
        longitude: {
          required: true,
          min_value: 0,
          max_value: 180
        },
        latitude: {
          required: true,
          min_value: 0,
          max_value: 180
        },
        radius: {
          required: true,
          min_value: 1000,
          max_value: 1000000
        },
        incoTerms: {
          required: true,
        }
      },
      form: {
        modesOfTransport: [],
        shipment: {
		  orderDevices: true,
          numberOfDevices: null,
          productGroupId: null,
          productGroupName: null,
          productDescription: null,
          destination: {
            longitude: "",
            latitude: "",
              radius: ""
          },
          fromAddress: {
            companyName: "",
            contact: {
              firstName: "",
              lastName: "",
              phone: "",
              email: "",
            },
            city: "",
            country: "",
            streetName: "",
            streetNumber: "",
            zipCode: "",
            addressExtension: ""
          },
          incoTerms: "",
        }
      },
      enumDef: enumDef,
      incotermOption: [
        {
          label: "DAP-Delivered at Place",
          value: "DAP",
        }
      ]
    };
  },
  methods: {
    changeProductGroup(data) {
      this.form.shipment.productGroupId = data.id;
      this.form.shipment.productGroupName = data.title;
      this.resetDeviceProfile();
    },
    getData() {
      return this.form;
    },
    isDisabled() {
      let disabled = false;
      if (this.readOnly) {
        disabled = true;
      }
      return disabled;
    },
    reset() {
      this.validate().catch(() => {
        /*ignore error*/
      });
    },
    onSelectCountry(data) {
      this.form.shipment.fromAddress.country = data;
    },
    validate() {
      return validateForm(this, this.$validator);
    },
    resetDeviceProfile() {
      if (this.contractData && this.contractData.shipment) {
        this.contractData.shipment.deviceProfileId = null;
        this.trackerForm.form.shipment.deviceProfileId = null
      }
    },
    next() {
      this.validate()
          .then(() => {
            this.$emit("next");
          })
          .catch(this.toast);
    },
    back() {
      this.$emit("back");
    },
    submitToReview() {
      this.$emit("review-relation");
    },
  },
  computed: {
    isFormValid() {
      return validateRequiredFields(this.form, this.modelValidations);
    }
  },
  mounted() {
    // init modes of transport
    this.form.modesOfTransport = [];
    for (let modeOfTransportKey in this.enumDef.modeOfTransport) {
      this.form.modesOfTransport.push({vModel: false, key: modeOfTransportKey, name: enumDef.modeOfTransport[modeOfTransportKey]});
    }

    if (this.contractData.shipment) {
      // EDIT mode: inject values
      this.form.shipment = {...this.contractData.shipment};
      // modes of transport
      this.form.modesOfTransport.filter((item) => this.form.shipment.selectedModesOfTransport.includes(item.key)).forEach((item) => item.vModel = true);
    }
  }
};
</script>
<style lang="scss">
.margin_2 {
  margin-top: 2px;
  margin-bottom: 2px;
}

.checkBox_group {
  display: flex;
  flex-direction: column;
}
</style>
